import { errorNotify } from '@js/utilities/bugsnag.js'
import { url } from '@js/utilities/url.js'
import axios from 'axios'

export default async function fetchWidgetData(identifier) {
    try {
        const response = await axios.get(url(`/api/widgets?sid=` + identifier))

        return response.data
    } catch (error) {
        errorNotify(
            'Failed fetching Widget Translation / Color network request',
            'error',
            'Widget Translation / Color',
            { error },
        )
        return null
    }
}
